export default {
    backendHost: function(){
        let host = window.location.hostname.toLowerCase();
        let result = 'http://localhost:1338';
        
        
        // staging demo
        if(host.includes('auth.staging.hopesg.org.sg')){
            result = 'https://auth.staging.hopesg.org.sg/api/'
        }

        if(host.includes('auth.hopesg.org.sg')){
            result = 'https://auth.hopesg.org.sg/api/'
        }
        return result;
    },
    
    mrsUrl: function(){
        let host = window.location.hostname.toLowerCase();
        let result = 'http://localhost:1338';
        
        
        // staging demo
        if(host.includes('auth.staging.hopesg.org.sg')){
            result = 'https://www.recruitment.staging.hopesg.org.sg'
        }

        if(host.includes('auth.hopesg.org.sg')){
            result = 'https://recruitment.hopesg.org.sg'
        }
        return result;
    }
}
